var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var NoteUnlocked = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0C9.23858 0 7 2.23858 7 5V9.58152C4.06817 10.7683 2 13.6426 2 17V23C2 23.5523 2.44772 24 3 24H14C18.4183 24 22 20.4183 22 16V10C22 9.44771 21.5523 9 21 9H10C9.66134 9 9.32759 9.02104 9 9.06189V5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5V6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6V5C17 2.23858 14.7614 0 12 0ZM4 17C4 13.6863 6.68629 11 10 11H20V16C20 19.3137 17.3137 22 14 22H4V17ZM12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 15.1792 10.0236 15.3528 10.0677 15.518L8.46447 17.1213C8.07394 17.5118 8.07394 18.145 8.46447 18.5355C8.85499 18.9261 9.48816 18.9261 9.87868 18.5355L11.482 16.9323C11.6472 16.9764 11.8208 17 12 17Z", fill: "currentColor" }) })));
};
